module.exports = __webpack_public_path__ + "img/huesik_logo_brown.71cab92c.png";